<template>
  <div class="news">
    <div class="policy">
      <div>
        <i></i>
        <h3>政策文件</h3>
      </div>
      <RouterLink
        target="_blank"
        :to="`/news/policy?firstCate=${domainList?.chID}&secondCate=${domainList?.coID}`"
      >
        更多 <el-icon><ArrowRight /></el-icon>
      </RouterLink>
    </div>
    <Transition name="fade">
      <div v-if="policyList.length" class="policy-news">
        <ul v-for="item in policyList" :key="item._id">
          <li>
            <RouterLink
              target="_blank"
              :title="item.neName"
              :to="`/news/newsdetail?clID=${domainList?.clID}&id=${item._id}`"
              >{{ item.neName }}</RouterLink
            >
          </li>
        </ul>
      </div>
      <PolicyNewsSkeleton v-else />
    </Transition>
  </div>
</template>

<script>
import PolicyNewsSkeleton from "./policy-news-skeleton.vue";
export default {
  components: {
    PolicyNewsSkeleton,
  },
  props: {
    policyList: {
      type: Array,
      default: () => [],
    },
    domainList: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.news {
  width: 400px;
  .policy {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 400px;
    background: rgb(244, 244, 244);
    div {
      display: flex;
      align-items: center;
      i {
        display: inline-block;
        width: 3px;
        height: 20px;
        background: @shColor;
      }
      h3 {
        margin-left: 10px;
      }
    }
    a {
      display: flex;
      align-items: center;
      color: #999;
      &:hover {
        color: @shColor;
      }
    }
  }
  .policy-news {
    width: 400px;
    margin-top: 5px;
    ul {
      padding: 5px 5px 5px 5px;
      & :hover {
        color: @shColor;
        cursor: pointer;
      }
      a {
        display: inline-block;
        width: 400px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-right: 10px;
      }
    }
  }
}
</style>
